module.exports = __webpack_public_path__ + "img/arrow-down-2.39a2045a.svg";